import { Link } from "react-router-dom";

export default function ArticleCard({ article, variant = "default" }) {
  if (variant === "hero") {
    return (
      <Link to={`/magazine/${article.slug}`} className="group block relative overflow-hidden h-[70vh] min-h-[500px]" data-testid={`article-hero-${article.slug}`}>
        <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/50 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-end p-6 sm:p-12 lg:p-16 max-w-4xl">
          <span className="label text-pfc-gold mb-4">{article.category} · Cover Story</span>
          <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl text-white leading-[0.9] uppercase tracking-tight">
            {article.title}
          </h1>
          <p className="text-white/70 text-sm lg:text-base mt-5 max-w-2xl font-body">{article.excerpt}</p>
          <div className="mt-6 font-sub uppercase tracking-[0.2em] text-xs text-white/60">
            By {article.author} · Read story →
          </div>
        </div>
      </Link>
    );
  }
  return (
    <Link to={`/magazine/${article.slug}`} className="group pfc-card block overflow-hidden" data-testid={`article-card-${article.slug}`}>
      <div className="relative aspect-[16/10] overflow-hidden">
        <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute top-3 left-3 label bg-ink-900/80 text-pfc-gold px-2 py-1 border border-pfc-gold/30">{article.category}</span>
      </div>
      <div className="p-5">
        <h3 className="font-display text-2xl text-white uppercase leading-tight group-hover:text-pfc-gold transition">{article.title}</h3>
        <p className="text-white/60 text-sm mt-3 font-body line-clamp-2">{article.excerpt}</p>
        <p className="mt-4 label text-white/40">By {article.author}</p>
      </div>
    </Link>
  );
}
